import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getAsset, getStyle } from '@utils/style';
import { Loading } from '@components/loading';
import { ReactComponent as CheckIcon } from '@icons/check.svg';
import { ReactComponent as WarningIcon } from '@icons/warning.svg';
import { ReactElement } from 'react';
import { QuestionnaireSelectorState } from '@app/types';

export const Success = (): ReactElement => {
  const { t } = useTranslation();
  const loading = useSelector((state: QuestionnaireSelectorState) => state.app.loading);
  const error = useSelector((state: QuestionnaireSelectorState) => state.app.error);
  const discarded = useSelector((state: QuestionnaireSelectorState) => state.app.discarded);

  if (loading) {
    return <Loading />;
  }

  return (
    <div
      className="link-status"
      style={{ borderColor: error ? getStyle('ERROR_COLOR') : getStyle('PRIMARY_COLOR', true) }}>
      <div className="link-status-logo">
        <img src={getAsset('image', getStyle('LOGO', true))} alt="" />
      </div>

      <div className="link-icon-container">
        {discarded ? (
          <>
            <span style={{ backgroundColor: getStyle('PRIMARY_COLOR', true) }}>
              <CheckIcon style={{ color: '#ffffff' }} />
            </span>
            <strong>{t('common:questionnaire.discarded')}</strong>
          </>
        ) : !error ? (
          <>
            <span style={{ backgroundColor: getStyle('PRIMARY_COLOR', true) }}>
              <CheckIcon style={{ color: '#ffffff' }} />
            </span>
            <strong>{t('common:questionnaire.success')}</strong>
          </>
        ) : (
          <>
            <WarningIcon style={{ color: getStyle('ERROR_COLOR') }} />
            <strong>{t('common:submissionFailed')}</strong>
          </>
        )}
      </div>

      <div className="link-separator" />
    </div>
  );
};
